// components/LayoutDefault.js
import React from "react";
import TopBar from "../components/TopBar";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import { useTracking } from "../hooks/useTracking";

const LayoutDefault = ({ children }) => {
  useTracking();

  return (
    <div className="flex flex-col min-h-screen font-sans">
      <TopBar />
      <main className="pt-12 sm:pt-[50px] md:pt-[55px] md1025:pt-[110px] xl:pt-[110px] 2xl:pt-[110px] bg-cinzaPadrao flex-1">
        <div className="grid grid-cols-1 lg:grid-cols-12 ">
          <div className="lg:col-span-8 xl:col-span-9 p-2 m-1">
            {children}
          </div>
          <div className="lg:col-span-4 xl:col-span-3 m-2">
            <Menu />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LayoutDefault;